import { Controller } from "@hotwired/stimulus";

// The "Votre nouveau copilote du quotidien" section: one tab per profile, auto-rotating like the
// reference mockup, and switchable by hand — a click resets the timer so it doesn't fight the
// visitor.
export default class extends Controller {
  static targets = ["tab", "panel", "dot"];
  static values = { interval: { type: Number, default: 4000 } };

  connect() {
    this.show(0);
    this.startTimer();
  }

  disconnect() {
    this.stopTimer();
  }

  select(event) {
    const index = Number(event.currentTarget.dataset.index);
    this.show(index);
    this.startTimer();
  }

  startTimer() {
    this.stopTimer();
    this.timerId = setInterval(() => {
      this.show((this.currentIndex + 1) % this.panelTargets.length);
    }, this.intervalValue);
  }

  stopTimer() {
    if (this.timerId) clearInterval(this.timerId);
  }

  show(index) {
    this.currentIndex = index;

    this.tabTargets.forEach((tab, i) => {
      tab.toggleAttribute("data-active", i === index);
    });

    this.dotTargets.forEach((dot, i) => {
      dot.toggleAttribute("data-active", i === index);
    });

    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("hidden", i !== index);
    });
  }
}
